<template>
  <v-dialog
    v-model="$ticketPackage.addProduct"
    class="rounded-lg"
    persistent
    max-width="1300"
    min-height="300"
    max-height="400"
    scrollable
  >
    <v-card class="base rounded-lg" tile>
      <v-toolbar flat dark color="base">
        <v-toolbar-title> Adicionar produto </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn class="mt-0 mr-0" dark icon @click="closeModal">
          <CloseIcon />
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card class="rounded-lg pa-4" elevation="0">
          <v-row>
            <v-col cols="3" class="d-flex flex-column">
              <BaseTextField
                tabindex="1"
                label="Pesquisar"
                placeholder="Ex: Bilhete"
                clearable
                hide-details
                :append-icon="$config.icons.search"
                v-model="search"
              />
              <v-progress-circular
                :size="50"
                color="#393939"
                indeterminate
                v-if="$produtos_gerenciar.produtos_loading"
              >
              </v-progress-circular>
              <span v-if="products.length === 0"
                >Nenhum produto com essa descrição encontrado.</span
              >
              <v-list
                class="py-0 mt-2 rounded-lg overflow-y-auto"
                height="400"
                min-height="400"
                max-height="600"
                v-else
              >
                <v-list-item-group v-model="selectedItem">
                  <v-list-item
                    v-for="(product, indexProd) in products"
                    :key="indexProd"
                    active-class="active-class"
                    class="rounded-lg"
                  >
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="product.descricao"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>
            <v-col cols="9">
              <template v-if="selectedItem === null">
                <span class="text-body-2 font-weight-bold"
                  >Selecione um produto</span
                >
              </template>
              <template v-else>
                <ProductContent
                  :product="products[selectedItem]"
                  @on-add="packageGenerate($event)"
                />
              </template>
            </v-col>
          </v-row>
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import ProductContent from "@/components/vendas/ProductContent.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import CloseIcon from "@/components/icons/CloseIcon.vue";
export default {
  name: "ModalProdutos",
  components: {
    ProductContent,
    BaseTextField,
    CloseIcon,
  },
  data() {
    return {
      selectedItem: 0,
      search: null,
    };
  },
  methods: {
    ...mapMutations(["setEvents", "setTempEvents"]),
    closeModal() {
      this.$ticketPackage.addProduct = false;
      this.selectedItem = 0;
    },
    packageGenerate(product) {
      this.$emit("generate", product);
      this.$ticketPackage.addProduct = false;
      this.selectedItem = 0;
    },
  },
  watch: {
    search(value) {
      if (value === null || value === undefined || value === "") {
        this.setEvents(this.allTempEvents);
      }

      let filtered = this.allEvents.filter(prod =>
        prod.descricao.toLowerCase().includes(value.toLowerCase())
      );

      if (filtered.length === 0) {
        this.setEvents([]);
      }

      this.setEvents(filtered);
    },
  },
  computed: {
    ...mapGetters(["allEvents", "allTempEvents"]),
    products() {
      if (this.$ticketPackage.productTab === 0) {
        const normalProducts = this.allEvents.filter(
          prod =>
            prod.tipo !== "CORTESIA" &&
            (prod.qtd_estoque > 0 || prod.qtd_estoque_var > 0)
        );

        const filterNormalVariations = normalProducts?.map(product => {
          const productVariations = product.variantes.opcoes.filter(
            option => option.taxa !== "CORTESIA" && option.taxa !== "GRATUIDADE"
          );

          return {
            ...product,
            variantes: {
              ...product.variantes,
              opcoes: productVariations,
            },
          };
        });

        return filterNormalVariations;
      }

      const productWithCourtesyOrGratuityTax = this.allEvents.filter(
        product => {
          return product.variantes.opcoes.some(option => {
            return option.taxa === "CORTESIA" || option.taxa === "GRATUIDADE";
          });
        }
      );

      const filterCourtesyOrGratuityVariations =
        productWithCourtesyOrGratuityTax?.map(product => {
          const productVariations = product.variantes.opcoes.filter(
            option => option.taxa === "CORTESIA" || option.taxa === "GRATUIDADE"
          );

          return {
            ...product,
            variantes: {
              ...product.variantes,
              opcoes: productVariations,
            },
          };
        });

      const courtesyProducts = this.allEvents.filter(
        prod =>
          prod.tipo === "CORTESIA" &&
          (prod.qtd_estoque > 0 || prod.qtd_estoque_var > 0)
      );

      courtesyProducts.push(...filterCourtesyOrGratuityVariations);

      return courtesyProducts.filter(
        (product, index, self) =>
          index ===
          self.findIndex(
            selfProduct => selfProduct.idproduto === product.idproduto
          )
      );
    },
    hasProducts() {
      return this.allEvents.length > 0;
    },
  },
};
</script>
<style scoped>
.active-class {
  background-color: #e6f7ff !important;
  border-color: #91d5ff !important;
  color: #1890ff !important;
}
.products-list {
  max-height: 346px;
  overflow-y: auto;
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
  cursor: pointer;
}
</style>
